import { TagChip } from '@/components/tags/TagChip';
import { SxStyle } from '@/utils/reactTypes';
import { gql } from '@apollo/client';
import { Tooltip } from '@mui/material';
import moment from 'moment';

export const PatientStatusTagFragment = gql`
    fragment PatientStatusTag on Patient {
        isDeceased
        deceasedAt
        isActive
    }
`;

// Inline-flex keeps the wrapper from adding line-height space below the chip.
const TOOLTIP_ANCHOR_STYLE = { display: 'inline-flex' };

interface PatientStatusTagProps {
    isDeceased: boolean;
    deceasedAt: Date | null;
    isActive: boolean;
    sx?: SxStyle;
}

export const PatientStatusTag = ({
    isDeceased,
    deceasedAt,
    isActive,
    sx,
}: PatientStatusTagProps) => {
    if (isDeceased) {
        const dateLabel = deceasedAt ? moment(deceasedAt).format('MMM D, YYYY') : '';
        return (
            <Tooltip title={`Deceased ${dateLabel}`.trim()}>
                <span style={TOOLTIP_ANCHOR_STYLE}>
                    <TagChip label='Deceased' size='small' sx={sx} />
                </span>
            </Tooltip>
        );
    }
    if (!isActive) {
        return <TagChip label='Inactive' size='small' sx={sx} />;
    }
    return null;
};
